const INTEGRATION_NAMES: Record<string, string> = {
  figma: "Figma",
  google: "Google",
  zoom: "Zoom",
  microsoft: "Microsoft",
  linkedin: "LinkedIn",
}

export const getIntegrationName = (path: string | null): string =>
  INTEGRATION_NAMES[path ?? ""] ?? ""
